/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */

import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import CommissionsPart from '../../Anagrafica/formParts/commissionsPart';
import ProductCommissionService from '../../../../shared/services/productcommission';

function CommissionsTab(props) {
  return (
    <>
      <CommissionsPart
        {...props}
        commissionService={ProductCommissionService}
        entity="product"
      />
    </>
  );
}

CommissionsTab.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(CommissionsTab);
